import Styled from 'styled-components';

import { media } from '../../../lib/StyledComponents';
import { SubNavLinks } from '../Common/SubNavLinks';

export const ScrollableSubNavLinks = Styled(SubNavLinks)`
  flex: 1 0 auto;
  padding-left: 1em;

  ${media.small`
    justify-content: flex-end;
  `}
`;
